module.exports = {"width":1440,"height":600,"type":"png"}